import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Shield, Heart, Lightbulb, Users } from 'lucide-react';

const PhilosophieSection = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
      },
    },
  };

  const philosophyItems = [
    {
      title: 'Vertrauen',
      description: 'Wir setzen auf transparente Kommunikation und zuverlässige Beratung als Grundlage aller unserer Kundenbeziehungen.',
      icon: Shield,
    },
    {
      title: 'Leidenschaft',
      description: 'Wir lieben was wir tun und setzen uns mit Begeisterung für die Bedürfnisse unserer Kunden ein.',
      icon: Heart,
    },
    {
      title: 'Innovation',
      description: 'Wir denken weiter und nutzen modernste Technologien und Methoden, um die Immobilienwelt von morgen zu gestalten.',
      icon: Lightbulb,
    },
    {
      title: 'Gemeinschaft',
      description: 'Wir schaffen nicht nur Gebäude, sondern Lebensräume, die Menschen verbinden und Gemeinschaft fördern.',
      icon: Users,
    },
  ];

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Background text */}
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.03] pointer-events-none overflow-hidden">
        <span className="text-[30vw] font-black whitespace-nowrap select-none text-black">WERTE</span>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">Unsere Philosophie</h2>
          <p className="text-gray-700 max-w-3xl mx-auto text-lg">
            Diese Grundwerte leiten unsere tägliche Arbeit und definieren, wofür YADE Home GmbH steht.
          </p>
        </motion.div>

        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
        >
          {philosophyItems.map((item, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="bg-white p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow rounded"
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 rounded-full bg-[#00C2CC]/10 flex items-center justify-center mb-6">
                  <item.icon className="w-8 h-8 text-[#00C2CC]" />
                </div>
                <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default PhilosophieSection;
